import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo/logo.svg";
import authlogo from "../../assets/images/logo/authlogo.svg";
import blacklogo from "../../assets/images/logo/blacklogo.png";

export default function Logo({ variant = "default", className = "", to = "/" }) {
  const logoSrc = variant === "auth" ? authlogo : variant === "black" ? blacklogo : logo;

  return (
    <NavLink to={to} className={`inline-flex ${className}`}>
      <img src={logoSrc} alt="HDF Logo" className="h-10 object-contain" />
    </NavLink>
  );
}
